import React from 'react'

const Divider: React.FC = () => {
  return <hr className="margin-none grey-30-border" />
}

export default Divider
